
import {
  getReagentList,
  CreateReagent,
  getMetaCvReagentAddInfoValueList,
  getMetaCvReagentTypeList,
  getReagentManufacturerList,
  modifyReagent,
  getReagentDetail,
  getReagentListSize,
  getReagentApplicationList,
  createReagentInPrepration,
  getMetaCvReagentConjugate
} from '../../api/reagent'

const reagents = {
  state: {
    reagentList: [],
    CvReagentTypeList: [],
    reagentManufacturerList: [],
    reagentApplicationList: [],
    addInfoList: [],
    reagentDetail: [],
    conjugateList: []
  },
  mutations: {
    SET_CONJUGATELIST (state, list) {
      console.log(list)
      state.conjugateList = list.map((item) => { return {label: item.ConjugateValue} })
    },
    SET_REAGENTLIST (state, data) {
      state.reagentList = data
    },
    SET_REAGENTDETAIL (state, data) {
      state.reagentDetail = data
    },
    SET_CVREAGENTTYPELIST (state, data) {
      state.CvReagentTypeList = data
    },
    SET_MANUFACTURERLIST (state, data) {
      state.reagentManufacturerList = data
    },
    SET_ADDINFOLIST (state, data) {
      state.addInfoList = data
    },
    SET_APLICATIONLIST (state, data) {
      state.reagentApplicationList = data
    }
  },
  actions: {
    getReagentList ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        getReagentList(data).then((res) => {
          commit('SET_REAGENTLIST', res.result.reagentList)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getReagentDetail ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        getReagentDetail(data).then((res) => {
          // console.log(res)
          commit('SET_REAGENTDETAIL', res.result.reagentList)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    CreateReagent ({commit}, data) {
      return new Promise((resolve, reject) => {
        CreateReagent(data).then((res) => {
          // commit('SET_REAGENTLIST', res)
          resolve(res)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getReagentNameAndType ({commit}, data) {
      return new Promise((resolve, reject) => {
        createReagentInPrepration(data).then((res) => {
          commit('SET_REAGENTLIST', res.result.createdReagentInfo)
          resolve(res.result.createdReagentInfo)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getMetaCvReagentAddInfoValueList ({commit}, data) {
      return new Promise((resolve, reject) => {
        getMetaCvReagentAddInfoValueList(data).then((res) => {
          // commit('SET_REAGENTLIST', res)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getMetaCvReagentTypeList ({commit}, data) {
      return new Promise((resolve, reject) => {
        getMetaCvReagentTypeList(data).then((res) => {
          commit('SET_CVREAGENTTYPELIST', res.result.metaCvReagentTypeList)
          resolve(res)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getReagentApplicationList ({commit}, data) {
      return new Promise((resolve, reject) => {
        getReagentApplicationList(data).then((res) => {
          commit('SET_APLICATIONLIST', res.result.reagentApplicationList)
          resolve(res)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getReagentManufacturerList ({commit}, data) {
      return new Promise((resolve, reject) => {
        getReagentManufacturerList(data).then((res) => {
          commit('SET_MANUFACTURERLIST', res.result.metaCvReagentManufacturerList)
          resolve(res)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    modifyReagent ({commit}, data) {
      return new Promise((resolve, reject) => {
        modifyReagent(data).then((res) => {
          resolve()
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getReagentListSize ({commit}, data) {
      return new Promise((resolve, reject) => {
        getReagentListSize(data).then((res) => {
          resolve(res)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getMetaCvReagentConjugate ({commit}) {
      return new Promise((resolve, reject) => {
        getMetaCvReagentConjugate().then((res) => {
          // console.log(res)
          commit('SET_CONJUGATELIST', res.result.metaCvReagentConjugateList)
          resolve(res.result.metaCvReagentConjugateList)
        }).catch(error => {
          console.log(error)
        })
      })
    }
  }
}
export default reagents



// WEBPACK FOOTER //
// ./src/store/modules/reagent.js